/**
 * Widths Wikimedia will actually serve.
 * Direct thumbnail requests must be one of:
 * 20, 40, 60, 120, 250, 330, 500, 960, 1280, 1920, 3840.
 * 400 and 800 return HTTP 400, so the card image never paints.
 */
export const DESTINATION_IMAGE_WIDTHS = [500, 960];

export const DESTINATION_CARD_SIZES = '(max-width: 600px) 180px, 380px';

export const CAMPAIGN_BANNER_SIZES = '(max-width: 600px) 100vw, 533px';

/** How many cards at the start of a horizontal carousel download immediately. */
export const CAROUSEL_EAGER_COUNT = 2;

function wikimediaThumb(url, width) {
  if (!url || typeof url !== 'string') return '';
  const thumbMatch = url.match(/^(https?:\/\/upload\.wikimedia\.org\/wikipedia\/commons\/thumb\/\w\/\w\w\/[^/]+)\/\d+px-(.+?)(\?.*)?$/);
  if (thumbMatch) return `${thumbMatch[1]}/${width}px-${thumbMatch[2]}`;
  const rawMatch = url.match(/^(https?:\/\/upload\.wikimedia\.org\/wikipedia\/commons)\/(\w\/\w\w)\/(.+?)(\?.*)?$/);
  if (rawMatch) return `${rawMatch[1]}/thumb/${rawMatch[2]}/${rawMatch[3]}/${width}px-${rawMatch[3]}`;
  return '';
}

/**
 * @param {string} src
 * @param {string} [sizes]
 * @returns {{ src: string, srcSet?: string, sizes?: string }}
 */
export function buildImageSources(src, sizes) {
  if (!src) return { src: '' };
  const small = wikimediaThumb(src, DESTINATION_IMAGE_WIDTHS[0]);
  const large = wikimediaThumb(src, DESTINATION_IMAGE_WIDTHS[1]);
  if (!small || !large) {
    return { src, ...(sizes ? { sizes } : {}) };
  }
  return {
    src: large,
    srcSet: `${small} ${DESTINATION_IMAGE_WIDTHS[0]}w, ${large} ${DESTINATION_IMAGE_WIDTHS[1]}w`,
    sizes: sizes || DESTINATION_CARD_SIZES,
  };
}

/**
 * @param {object | null | undefined} destination
 * @returns {{ src: string, alt: string }}
 */
export function destinationImageProps(destination) {
  const src = destination?.output_json?.hero?.image
    || destination?.hero_image
    || destination?.image
    || '';
  const alt = destination?.output_json?.hero?.title
    || destination?.destination
    || destination?.title
    || destination?.name
    || '';
  return { src, alt };
}
